import { useMemo } from 'react';

import { HoldingClass, Transaction } from 'types';

import { getTransactionSharesCount } from 'modules/transactions/utils/getTransactionSharesCount';
import { getTransactionAmount } from 'modules/transactions/pages/OperationDetails/utils/getTransactionAmount';

import { getTransactionTypeLabelKey } from '../utils/getTransactionTypeLabelKey';

type UseGetTransactionDataProps = {
  transaction: Transaction;
  operationType: string;
  nominalValue: number;
};

export const useGetTransactionData = ({
  transaction,
  operationType,
  nominalValue,
}: UseGetTransactionDataProps) => {
  const data = useMemo(() => {
    if (!transaction) {
      return {
        type: '',
        className: '',
        from: 0,
        to: 0,
        sharesCount: 0,
        amount: 0,
      };
    }

    const type = getTransactionTypeLabelKey({
      transactionType: transaction.transactionType,
      operationType,
    });

    const className = (transaction.shareClass as HoldingClass)?.name || '';
    const from = transaction.shareFrom || 0;
    const to = transaction.shareTo || 0;
    const sharesCount = getTransactionSharesCount(transaction);
    const amount = getTransactionAmount({
      transaction,
      sharesCount,
      nominalValue,
    });

    return {
      type,
      className,
      from,
      to,
      sharesCount,
      amount,
    };
  }, [transaction, operationType, nominalValue]);

  return {
    data,
  };
};
